import type React from "react";
import { Avatar, Tooltip } from "@mui/material";
import { rawColor } from "../../constants/colors";
import { getInitials } from "../../utils/userUtils";

interface InitialsAvatarProps {
  name: string;
  size?: number;
  tooltipText?: string;
}

const hashName = (name: string) => {
  let hash = 0;
  for (let index = 0; index < name.length; index += 1) {
    hash = name.charCodeAt(index) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ name, size = 32, tooltipText }) => {
  const hash = hashName(name);
  const avatar = (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: rawColor.avatar.colors[hash % rawColor.avatar.colors.length],
        backgroundImage: rawColor.avatar.patterns[hash % rawColor.avatar.patterns.length],
        backgroundSize: "8px 8px",
        fontSize: size * 0.4,
        color: rawColor.white.main,
        fontWeight: [400, 500, 600, 700][hash % 4],
        boxShadow: rawColor.shadow.light.small,
        border: `2px solid ${rawColor.white.transparent["03"]}`,
        "&:hover": {
          transform: "scale(1.05)",
          transition: "transform 0.2s ease-in-out",
          boxShadow: rawColor.shadow.light.large,
        },
      }}
    >
      {getInitials(name, 2)}
    </Avatar>
  );

  return <Tooltip title={tooltipText || name}>{avatar}</Tooltip>;
};

export default InitialsAvatar;
